import { render } from "./info-comp1.vue?vue&type=template&id=53e1c0e8&scoped=true"
import script from "./info-comp1.vue?vue&type=script&lang=js"
export * from "./info-comp1.vue?vue&type=script&lang=js"

import "./info-comp1.vue?vue&type=style&index=0&id=53e1c0e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e1c0e8"]])

export default __exports__